import { View, Text, IconCircle, Button } from '@/components'
import { theme } from '@/config'
import { AppIcon } from '@codeleap/styles'
import { PropsOf } from '@codeleap/types'

export type CustomPlaceholderProps = {
  iconName: AppIcon
  iconSize?: number
  title: string
  description: string
  subTitle?: string
  buttonProps?: PropsOf<typeof Button>
}

export const CustomPlaceholder = (props: CustomPlaceholderProps) => {
  const { iconName, title, description, subTitle, iconSize = 46, buttonProps } = props

  return (
    <View style={['fullWidth', 'fullHeight', 'column', 'center', 'gap:3']}>
      <IconCircle
        icon={iconName}
        size={iconSize}
        bgCircle={theme.baseColors.primarySolid50}
        bgIcon={theme.baseColors.primarySolid100}
        color={theme.baseColors.primarySolid500}
      />

      <View style={['column', 'center', 'gap:1.2', 'textCenter', 'px:4']}>
        <Text style={['h3', { color: theme.colors.textCaption }]} text={title} />

        {!!subTitle && (<Text style={['p3', { color: theme.colors.textParagraph }]} text={subTitle} />)}

        <Text style={['p3', { color: theme.colors.textParagraph }]} text={description} />
      </View>

      {!!buttonProps && <Button {...buttonProps} />}
    </View>
  )
}
